import Vue from 'vue'
import defaultState from './state'

export default {
  setCurrentCompany: (state, payload) => { state.currentCompany = payload },
  setIsCallingCompany: (state, payload) => { state.isCallingCompany = payload },
  /* Dynamic Validations */
  setOfficeFormConfigurations: (state, payload) => {
    state.officeFormConfigurations = payload
  },
  updateOfficeFormConfiguration: (state, payload) => {
    if (payload.form === 'TRANSACTION_BILL') {
      state.officeFormConfigurations.TRANSACTION = state.officeFormConfigurations.TRANSACTION || {}
      state.officeFormConfigurations.TRANSACTION.BILL = payload
    } else if (payload.form === 'EXPENSE_BILL') {
      state.officeFormConfigurations.EXPENSE = state.officeFormConfigurations.EXPENSE || {}
      state.officeFormConfigurations.EXPENSE.BILL = payload
    } else if (payload.form === 'TRANSACTION') {
      state.officeFormConfigurations.TRANSACTION = state.officeFormConfigurations.TRANSACTION || {}
      state.officeFormConfigurations.TRANSACTION.RECEIPT = payload
    } else if (payload.form === 'EXPENSE') {
      state.officeFormConfigurations.EXPENSE = state.officeFormConfigurations.EXPENSE || {}
      state.officeFormConfigurations.EXPENSE.RECEIPT = payload
    } else {
      state.officeFormConfigurations[`${payload.form}`] = payload
    }
  },
  setIsFuellFrozen: (state, payload) => { state.isFuellFrozen = payload },
  clearStoreData: state => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      Vue.set(state, key, initialState[key])
    })
  }

}
